import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import remoteServices from '~/constants/RemoteServices';
import {postHeaders, rfeCredentialsHeader} from '~/utils/http';

export const priceQuoteApi = createApi({
  reducerPath: 'priceQuoteApi',
  baseQuery: fetchBaseQuery({
    ...postHeaders,
    baseUrl: remoteServices.price_quote,
    credentials: rfeCredentialsHeader
  }),
  endpoints: builder => ({
    // https://github.com/customink/rails-frontend/blob/ee410dfdbaefe43cd93e4e6e1f44f7d51d430f5f/app/views/price_quote/new.json.erb
    getPriceQuote: builder.query({
      query: config => {
        return {
          url: '/',
          method: 'POST',
          body: {quote_info: config}
        };
      }
    })
  })
});

export const {useGetPriceQuoteQuery, endpoints: priceQuoteEndpoints} =
  priceQuoteApi;
